import { render, staticRenderFns } from "./SaveBuildingPositionLacks.vue?vue&type=template&id=42ec74ef&scoped=true&"
import script from "./SaveBuildingPositionLacks.vue?vue&type=script&lang=js&"
export * from "./SaveBuildingPositionLacks.vue?vue&type=script&lang=js&"
import style0 from "./SaveBuildingPositionLacks.vue?vue&type=style&index=0&id=42ec74ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec74ef",
  null
  
)

export default component.exports